// CRM layer — "إعادة إسناد" modal (Batch 2, item 1).
//
// Managers (assign_opportunity holders) reassign an existing opportunity to a
// chosen agent from the calls screen. The backend allows this at ANY stage.
// Agent list comes from /auth/users/names.

import React, { useEffect, useState } from 'react';
import { crmAssign, crmUserNames } from './crmApi';
import { modalOpen, modalClosed } from './modalGuard';

const CrmReassignModal = ({ opportunityId, currentExtension, onClose, onDone }) => {
  const [agents, setAgents] = useState([]);
  const [ext, setExt] = useState(currentExtension || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  // Pause the host page's auto-refresh while open (item 6 guard).
  useEffect(() => { modalOpen(); return () => modalClosed(); }, []);
  useEffect(() => { crmUserNames().then((r) => setAgents(r.data.users || [])).catch(() => setAgents([])); }, []);

  const submit = async () => {
    if (!ext) { setError('اختر موظفاً'); return; }
    setSaving(true); setError('');
    try {
      await crmAssign(opportunityId, ext);
      if (onDone) onDone();
      onClose();
    } catch (e) {
      setError(e.response?.data?.error || 'فشل الإسناد');
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay crm-calm" onClick={onClose}>
      <div className="modal crm-scope" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>إعادة إسناد الطلب</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <p className="crm-modal-note" style={{ marginBottom: 12 }}>
          اختر الموظف الذي سيُسند إليه هذا الطلب (متاح في أي مرحلة).
        </p>
        <select className="filter-select" style={{ width: '100%' }} value={ext} onChange={(e) => setExt(e.target.value)}>
          <option value="">— اختر موظفاً —</option>
          {agents.map((a) => <option key={a.extension} value={a.extension}>{a.fullName} ({a.extension})</option>)}
        </select>
        {error && <div className="crm-modal-err" style={{ marginTop: 10, marginBottom: 0 }}>{error}</div>}
        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button className="btn btn-primary" disabled={saving} onClick={submit}>{saving ? 'جارٍ...' : 'إسناد'}</button>
          <button className="btn btn-outline" onClick={onClose}>إلغاء</button>
        </div>
      </div>
    </div>
  );
};

export default CrmReassignModal;
